import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

import {booleanMetadata} from '../../../../../utils/builderMetadata'

export type DisplaySettingsParams = {
  showBreadcrumbs: SettingsParamType.Boolean
  showImage: SettingsParamType.Boolean
  showSummary: SettingsParamType.Boolean
  showDuration: SettingsParamType.Boolean
  showDate: SettingsParamType.Boolean
  showPrice: SettingsParamType.Boolean
  showCapacity: SettingsParamType.Boolean
  showAboutSection: SettingsParamType.Boolean
}

export const DEFAULT_DISPLAY_SETTINGS_PARAMS: Record<keyof DisplaySettingsParams, any> = {
  showBreadcrumbs: true,
  showImage: true,
  showSummary: true,
  showDuration: true,
  showDate: true,
  showPrice: true,
  showCapacity: true,
  showAboutSection: true,
}

export const displaySettingsParams = createSettingsParams<DisplaySettingsParams>({
  showBreadcrumbs: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showBreadcrumbs,
    metadata: booleanMetadata(
      DEFAULT_DISPLAY_SETTINGS_PARAMS.showBreadcrumbs,
      'Shows or hides the breadcrumbs at the top of the experience page',
    ),
  },
  showImage: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showImage,
    metadata: booleanMetadata(
      DEFAULT_DISPLAY_SETTINGS_PARAMS.showImage,
      'Shows or hides the experience image',
    ),
  },
  showSummary: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showSummary,
    metadata: booleanMetadata(
      DEFAULT_DISPLAY_SETTINGS_PARAMS.showSummary,
      'Shows or hides the experience summary under the name',
    ),
  },
  showDuration: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showDuration,
    metadata: booleanMetadata(
      DEFAULT_DISPLAY_SETTINGS_PARAMS.showDuration,
      'Shows or hides the experience duration',
    ),
  },
  showDate: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showDate,
    metadata: booleanMetadata(
      DEFAULT_DISPLAY_SETTINGS_PARAMS.showDate,
      'Shows or hides the experience date',
    ),
  },
  showPrice: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showPrice,
    metadata: booleanMetadata(
      DEFAULT_DISPLAY_SETTINGS_PARAMS.showPrice,
      'Shows or hides the experience price',
    ),
  },
  showCapacity: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showCapacity,
    metadata: booleanMetadata(
      DEFAULT_DISPLAY_SETTINGS_PARAMS.showCapacity,
      'Shows or hides the guest capacity of the experience',
    ),
  },
  showAboutSection: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showAboutSection,
    metadata: booleanMetadata(
      DEFAULT_DISPLAY_SETTINGS_PARAMS.showAboutSection,
      'Shows or hides the About section with the experience description',
    ),
  },
})
